import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { addTask, getMyKPIs } from "../../utils/helper";
import { alertSuccess, alertError } from "../../utils/alerts";
import Loader from "../../utils/Loader";

const INIT_STATE = {
    task_title: "",
    task_description: "",
    task_deadline: "",
    task_kpi: "",
    task_status: "not started",
};

export default function AddTask() {
    const [kpis, setKPIs] = useState(null);
    const [state, setState] = useState(INIT_STATE);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    useEffect(() => {
        setLoading(true);
        getMyKPIs()
            .then((res) => {
                setKPIs(res.data.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err.response)
                setLoading(false);
            });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(state.task_title && state.task_deadline && state.task_description && state.task_kpi){
            setLoading(true);
            addTask(state)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    alertError(err.response?.data?.error);
                    setLoading(false);
                });
        }
    };
    
    return (
        <>
            <h1 className="dash-title"><Link to="/performance/tasks" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link></h1>

            <div className="row dash-row">
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Create Daily Task</div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                            {(!loading && kpis && kpis) ? (
                                <form method="post" encType="multipart/form-data" onSubmit={handleSubmit}>
                                    {(kpis && kpis.length > 0) ? <>
                                    <div className="row">
                                        <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">KPI: <span>*</span></label>
                                            <select className="form-control form-select" name="task_kpi" id="task_kpi" required  
                                            onChange={handleChange} defaultValue={state.task_kpi}>
                                                <option value=''>Select KPI</option>
                                                {kpis && kpis.map((item, i) => (
                                                    <option key={i} value={item._id}>{item.kpi}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">Task Title: <span>*</span></label>
                                            <input name="task_title" type="text" placeholder="Task Title" className="form-control" required 
                                            onChange={handleChange} defaultValue={state.task_title}/>
                                        </div>
                                        <div className="col-md-4 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">Task Deadline: <span>*</span></label>
                                            <input name="task_deadline" type="date" placeholder="Task Deadline" className="form-control" required 
                                            onChange={handleChange} defaultValue={state.task_deadline}/>
                                        </div>
                                        <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                                            <label className="control-label">Task Description: <span>*</span></label>
                                            <textarea name="task_description" cols="33" rows="4" placeholder="Task Description" className="form-control" required 
                                            onChange={handleChange} defaultValue={state.task_description} ></textarea>
                                        </div>
                                    </div>
                                    <div className="row form-group">
                                        <div className="col-md-12 col-sm-12">
                                            <button 
                                                type="submit" 
                                                disabled={loading}
                                                className="btn btn-primary" 
                                                onClick={() => handleSubmit}
                                                >
                                                CREATE
                                            </button>
                                        </div>
                                    </div> </> : 
                                    <div className="alert alert-danger myerror d-block">Your KPI has not been uploaded yet. You will be able to create tasks after PSM uploads your KPIs.</div>}
                                </form>
                                ) : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
